/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'
import { SCROLL_TOP_THRESHOLD } from '@/utils/constants'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { useIsMobile } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { Button } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

const ScrollContainer = styled.div<any>`
  position: fixed;
  right: 2rem;
  bottom: ${(props) => props.bottom};
  opacity: ${(props) => props.opacity};
  visibility: ${(props) => props.visibility};
  transition: 0.5s;
  z-index: 10;
  svg {
    transform: rotate(90deg);
  }
  .ant-btn {
    min-width: 40px;
    padding: 8px;
    height: auto;
  }
  .ant-btn.ant-btn-circle.ant-btn {
    min-width: 40px;
  }
`

const ScrollToTopButton = () => {
  const [isMobile] = useIsMobile()
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const checkScrollOffset = () => {
      if (typeof window === 'undefined') return
      setShowButton(window.scrollY > SCROLL_TOP_THRESHOLD)
    }
    window.addEventListener('scroll', checkScrollOffset)

    return () => window.removeEventListener('scroll', checkScrollOffset)
  }, [])

  const scrollToTop = () => {
    if (typeof window === 'undefined') return
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  const bottomBySize = isMobile ? '14rem' : '7rem'
  const bottom = showButton ? bottomBySize : '3rem'
  const visibility = showButton ? 'visible' : 'hidden'
  const opacity = showButton ? 1 : 0

  return (
    <ScrollContainer bottom={bottom} visibility={visibility} opacity={opacity}>
      <Button
        onClick={() => scrollToTop()}
        type="primary"
        style={{
          width: 40,
          height: 40,
          padding: 0,
          margin: 0,
          borderRadius: '50%',
        }}
      >
        <Icon
          className="ph-arrow-up"
          size="24"
          color="var(--color-white)"
          style={{ position: 'relative', top: 2 }}
        />
      </Button>
    </ScrollContainer>
  )
}

export default ScrollToTopButton
